import type { SKUFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/skus';

export const skusFromToUpdateConverter = (skus?: SKUFormSchema[] | null) => {
  if (!Array.isArray(skus) || skus.length === 0) {
    return [];
  }
  return skus.map((item) => ({ sku_id: item.id, primary: (item?.pivot?.primary ?? 0) === 1 }));
};
